import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AlertService from "../../components/Alerts/alerts";
import AuthService from "../Authentication/auth.service";

const DetailedInfoTab = ({ userData, setUserData }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    business_id: userData?.business_id,
    user_id: userData?._id,
    registration_number: '',
    sst_registration_number: '',
    PostalZone: '',
    phone: '',
    tin: '',
    id_type: '',
    id_value: '',
    address: '',
    CityName: '',
    CountrySubentityCode: '14',
    AddressLine1: '',
    AddressLine2: '',
    IdentificationCodeCountry: 'MYS',
  });

  const { t } = useTranslation();

  useEffect(() => {
    // Populate form data with existing user data
    setFormData(prevState => ({
      ...prevState,
      ...userData,
    }));
  }, [userData]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await AuthService.Update_User(formData);
      if (response.data.status) {
        const updatedUser = { ...userData, ...formData };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        setUserData(updatedUser);
        AlertService.swalSuccessAlert(t("Information updated successfully!"));
      } else {
        handleAuthError(response.data);
      }
    } catch (error) {
      AlertService.swalErrorAlert(t("Network Operation failed."));
    } finally {
      setLoading(false);
    }
  };

  const handleAuthError = (data) => {
    if (data.message === "Unauthorized") {
      AuthService.logout();
      // Note: navigation should be handled in the parent component
      AlertService.swalErrorAlert(t("Your session has expired. Please log in again."));
    } else {
      AlertService.swalErrorAlert(data.message || t("Error: Can't update user at the moment. Please try again later."));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("Registration Number")}
            name="registration_number"
            value={formData.registration_number}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("SST Registration Number")}
            name="sst_registration_number"
            value={formData.sst_registration_number}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("TIN")}
            name="tin"
            value={formData.tin}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            label={t("ID Type")}
            name="id_type"
            value={formData.id_type}
            onChange={handleInputChange}
            required
          >
            <MenuItem value="BRN">BRN</MenuItem>
            <MenuItem value="SSM">SSM</MenuItem>
            <MenuItem value="PASSPORT">Passport</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("ID Value")}
            name="id_value"
            value={formData.id_value}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("Address")}
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            multiline
            rows={3}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("City Name")}
            name="CityName"
            value={formData.CityName}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("Postal Zone")}
            name="PostalZone"
            value={formData.PostalZone}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("Address Line 1")}
            name="AddressLine1"
            value={formData.AddressLine1}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("Address Line 2")}
            name="AddressLine2"
            value={formData.AddressLine2}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("Contact Number")}
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
        </Grid>
      </Grid>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        disabled={loading}
      >
        {t("Update")}
      </Button>
    </form>
  );
};

export default DetailedInfoTab;